import { HistoryAdapter } from "./context";

export type PingQueryParameterType = null | string | string[];

const setQueryParameters = (
  query: URLSearchParams,
  history: HistoryAdapter,
  paramsMap: Record<string, PingQueryParameterType>,
  replace: boolean = false,
) => {
  // Create a fresh copy to avoid race conditions when multiple updates
  // happen before React re-renders with new searchParams
  const freshQuery = new URLSearchParams(window.location.search);

  for (const [param, value] of Object.entries(paramsMap)) {
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
    ) {
      freshQuery.delete(param);
    } else if (Array.isArray(value)) {
      freshQuery.delete(param);
      value.forEach((v) => freshQuery.append(param, v));
    } else {
      freshQuery.set(param, value.toString());
    }
  }

  if (replace) {
    history.replace({
      search: freshQuery.toString(),
    });
  } else {
    history.push({
      search: freshQuery.toString(),
    });
  }
};

export const pushQueryParameters = (
  query: URLSearchParams,
  history: HistoryAdapter,
  paramsMap: Record<string, PingQueryParameterType>,
) => setQueryParameters(query, history, paramsMap, false);

export const replaceQueryParameters = (
  query: URLSearchParams,
  history: HistoryAdapter,
  paramsMap: Record<string, PingQueryParameterType>,
) => setQueryParameters(query, history, paramsMap, true);
